import ViaqTryCatch from "../../../services/GlobalTryCatch";
import axiosInstance from "../../../services/axios";

export default class NewOrderRepository {
    static async getnewOrder() {

        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.get("/dashboard/get-order")
            });

        const countAll = response.data.countAll;
        const codeOrder = response.status.code;
        const massageorder = response.status.massage;
        return {
            code: response.statusCode,
            message: response.message,
            countAll,
            codeOrder,
            massageorder,
        };
    }

    static async deleteNewOrder(id) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/dashboard/delete-order", id)
            });
        return {
            code: response.statusCode,
            message: response.message,
        };
    }
}
// return new Neworder(order.date,order.number,order.device_number)
